/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { BrandLogo } from '@components/ui/Brand';
import { isManagerVar } from '@graphql/cache';
import { Stack, StackProps, Tooltip, Typography, styled } from '@mui/material';
import { readFromCookies } from '@utils/cookies';
import { useTranslation } from 'next-i18next';
import { FC, useEffect, useState } from 'react';

import { StorageTokens } from '@/lib/constants';

const SidebarBrandRoot = styled(Stack, {
  name: 'SidebarBrand',
  slot: 'Root',
})(({ theme }) => ({
  typography: theme.typography.h4,
  color: theme.palette.dark['900'],
  userSelect: 'none',
}));

const SidebarBrandName = styled(Typography, {
  name: 'SidebarBrand',
  slot: 'Name',
})(({ theme }) => ({
  width: '100%',
  fontSize: 14,
  fontWeight: 400,
  textOverflow: 'ellipsis',
  color: theme.palette.dark['800'],
}));

type Workshop = {
  id: string;
  name: string;
};

const SidebarBrand: FC<StackProps> = (props) => {
  const [workshop, setWorkshop] = useState<Workshop>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const manager = isManagerVar();
    if (!manager) {
      return;
    }

    const name = readFromCookies<string>(StorageTokens.SELECTED_WORKSHOP_NAME);
    const id = readFromCookies<string>(StorageTokens.SELECTED_WORKSHOP);

    setWorkshop({
      name,
      id,
    });
  }, []);

  return (
    <SidebarBrandRoot direction="row" justifyContent="flex-start" flexWrap="nowrap" {...props}>
      <Stack alignItems="center" justifyContent="center" flexGrow={0} flexShrink={0}>
        <BrandLogo />
      </Stack>

      <Stack
        flexGrow={1}
        flexShrink={1}
        direction="column"
        alignItems="flex-start"
        justifyContent="center"
        sx={{ pl: 1.5, overflow: 'hidden' }}
      >
        <Typography component="h1" noWrap sx={{ fontSize: 10, fontWeight: 500 }}>
          {t('SUPPLIERS')}
        </Typography>

        {workshop && (
          <Tooltip title={`${workshop.id}: ${workshop.name}`}>
            <SidebarBrandName variant="body2" noWrap>
              {workshop.name}
            </SidebarBrandName>
          </Tooltip>
        )}
      </Stack>
    </SidebarBrandRoot>
  );
};

export default SidebarBrand;
